<template>
  <div class="card card-custom card-stretch gutter-b" style="max-height: 50.75vh; padding: 0.5rem;">
    <div class="card-header border-0" style="padding: 1rem 1rem 0rem 1rem;">
      <h3 class="card-title font-weight-bolder text-dark">การแจ้งเตือน</h3>
      <div class="card-toolbar">
        <Dropdown2></Dropdown2>
      </div>
    </div>
    <div class="card-body pt-2" style="overflow: auto; padding: 1rem;">
      <div v-if="list.length > 0">
        <template v-for="(item, i) in list">
          <div class="mb-6" :key="i">
            <div class="d-flex align-items-center flex-grow-1" style="background-color: rgb(243,246,249); padding: 1rem; border-radius: 10px;">
              <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                <div class="d-flex flex-column align-items-cente py-2 w-75">
                  <span class="text-dark-75 font-weight-bold font-size-lg mb-1">{{ item.title }}</span>
                  <span class="text-danger font-weight-bold">{{ item.desc }}</span>
                </div>
                <span class="label label-xl label-inline font-weight-bold py-4" v-bind:class="`label-light-${item.class}`">{{ item.due_date }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="row" style="margin-top: 15%;" v-else>
        <div class="col-12 d-flex justify-content-center">
          <img src="../../../../public/media/error/no_data.png" width="150" height="100" >
        </div>
        <div class="col-12 d-flex justify-content-center">
          <span style="font-weight: 700; font-size: 1.275rem;">No data</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import FetchService from "@/core/services/fetch.service";
import moment from 'moment';

export default {
  name: "Widget13",
  data() {
    return {
      list: [
        {
          title: "อาคารทดสอบ 1",
          desc: "สัญญาใกล้ครบกำหนด",
          due_date: "อีก 26 วัน",
          class: "warning"
        },
        {
          title: "อาคารทดสอบ 2",
          desc: "สัญญาใกล้ครบกำหนด",
          due_date: "อีก 27 วัน",
          class: "warning"
        },
        {
          title: "อาคารทดสอบ 3",
          desc: "สัญญาใกล้ครบกำหนด",
          due_date: "อีก 28 วัน",
          class: "warning"
        },
        {
          title: "อาคารทดสอบ 4",
          desc: "สัญญาใกล้ครบกำหนด",
          due_date: "อีก 29 วัน",
          class: "warning"
        },
        {
          title: "อาคารทดสอบ 5",
          desc: "สัญญาใกล้ครบกำหนด",
          due_date: "อีก 30 วัน",
          class: "warning"
        }
      ],
      listMasterData: [],
    };
  },
  components: {
    Dropdown2
  },
  mounted() {
    this.getAlarm()
  },
  methods: {
    getAlarm() {
      FetchService.get("/getcontract/alarm", res => {
        if (res) {
          res = JSON.parse(res)
          this.list = res.list_alarm.map(e => {
            return {
              ...e,
              due_date: moment(e.due_date).format("YYYY-MM-DD")
            }
          })
          // this.pageInit()
        }
      })
    }
  }
};
</script>
